import { FileReader, FileWriter } from '@/platform'
import FloatButtonData from './FloatButtonData'

class FloatButton {
    /**
     * 悬浮按钮集合
     */
    public FBtnList: FloatButtonData[] = []

    readBin(reader: FileReader): void {
        this.FBtnList = []
        const len = reader.readInt()
        for (var i = 0; i < len; i++) {
            let fb = new FloatButtonData(reader)
            this.FBtnList.push(fb)
        }
    }

    writeBin(writer: FileWriter): void {
        writer.writeInt(this.FBtnList.length)
        for (let i = 0; i < this.FBtnList.length; i++) {
            const fb = this.FBtnList[i]
            fb?.writeBin(writer)
        }
    }

    writeGameBin(writer: FileWriter, engineVersion: number): void {
        if (engineVersion < 104) {
            return
        }
        writer.writeInt(this.FBtnList.length)
        for (let i = 0; i < this.FBtnList.length; i++) {
            this.FBtnList[i]?.writeGameBin(writer)
        }
    }
}
export default FloatButton
